import { Mail, Phone, Facebook, Twitter, Linkedin } from 'lucide-react';
import { mockData } from '../utils/mock';

export const Footer = ({ onPrivacyClick, onTermsClick }) => {
  const { contactInfo } = mockData;

  return (
    <footer className="bg-gray-900 text-gray-300" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_import-duty-waiver/artifacts/fhafaydj_dd094932-baad-4705-8321-6271ac8eee4b.jpeg" 
              alt="TOR1 Services Logo" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 mb-4">
              Your trusted partner for Transfer of Residence services. Helping UK nationals relocate their personal belongings and furniture from overseas back to the UK duty-free.
            </p>
            <nav className="flex space-x-4" aria-label="Social media links">
              <a href="#" className="hover:text-blue-400 transition-colors" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="hover:text-blue-400 transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="#" className="hover:text-blue-400 transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </nav>
          </div>

          {/* Quick Links */}
          <nav aria-label="Footer navigation">
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="hover:text-blue-400 transition-colors">Services</a>
              </li>
              <li>
                <a href="#relocation-routes" className="hover:text-blue-400 transition-colors">Relocation Routes</a>
              </li>
              <li>
                <a href="#benefits" className="hover:text-blue-400 transition-colors">Benefits</a>
              </li>
              <li>
                <a href="#faq" className="hover:text-blue-400 transition-colors">FAQ</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-blue-400 transition-colors">Contact</a>
              </li>
              <li>
                <button onClick={onPrivacyClick} className="hover:text-blue-400 transition-colors">Privacy Policy</button>
              </li>
              <li>
                <button onClick={onTermsClick} className="hover:text-blue-400 transition-colors">Terms & Conditions</button>
              </li>
            </ul>
          </nav>

          {/* Contact Info */}
          <address className="not-italic">
            <h4 className="text-lg font-semibold text-white mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Mail size={20} className="mr-3 mt-1 flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-blue-400 transition-colors break-all">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start">
                <Phone size={20} className="mr-3 mt-1 flex-shrink-0" />
                <a href={`tel:${contactInfo.phone}`} className="hover:text-blue-400 transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
            </ul>
          </address>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>
            &copy; {new Date().getFullYear()} TOR1 Services. All rights reserved. Authorized UK customs services provider. | 
            <button onClick={onPrivacyClick} className="hover:text-blue-400 transition-colors underline ml-2">Privacy Policy</button> | 
            <button onClick={onTermsClick} className="hover:text-blue-400 transition-colors underline ml-2">Terms & Conditions</button>
          </p>
        </div>
      </div>
    </footer>
  );
};
